export default {
  menu: {
    about: "About",
    getStarted: "Get Started",
    docs: "Docs",
    gitHub: "GitHub",
  },
  about: {
    title: "What is StarryGL?",
    content:
      "\nStarryGL is a robust distributed framework designed for training temporal graph neural networks at scale. It supports a variety of graph neural network models, including static graph neural networks, continuous-time dynamic graph neural networks, and discrete-time dynamic graph neural networks. StarryGL offers a comprehensive suite of functional components, including graph partitioning, storage, sampling, feature caching, model training, and memory update synchronization. In comparison to existing temporal graph neural network frameworks, StarryGL stands out for its superior training efficiency, boasting a 0.73 to 6.98 times improvement in efficiency while maintaining comparable accuracy. ",
    content2:
      "\nThe exceptional performance of StarryGL can be attributed to the optimization of multiple modules, such as multi-weight load-balanced graph partitioning, efficient and scalable parallel sampling, distributed and efficient reading and writing of subgraph feature caches, and distributed parallel training. These optimizations have led to significant improvements, including:\n    - a 24% to 40% reduction in temporal graph sampling time;\n    - a 1.41 to 2.47 times increase in temporal graph sampling throughput;\n    - a 2x improvement in data preparation performance, a 1.5x improvement in data write back performance;\n    - a 3-5x improvement in neighbor aggregation performance. \n\nTo experience the power of StarryGL, visit the Get Started section to download and use the framework. For more in-depth information, consult the public documentation.",
  },
  home: {
    title: "Starry Graph Learning",
    introduction:
      "StarryGL is a distributed framework that enables efficient and scalable training of temporal graph neural networks for large-scale data sets.",
    efficientTitle: "One-Stop Graph Learning System",
    efficientContent:
      "A comprehensive temporal graph learning system with components for graph partitioning, storage, sampling, feature caching, model training, and memory update synchronization.",
    temporalTitle: "General Temporal Graph Supporting",
    temporalContent:
      "Support for various graph learning models, including static graph neural networks, continuous-time dynamic graph neural networks, and discrete-time dynamic graph neural networks.",
    leaderTitle: "Efficient and Scalable",
    leaderContent:
      "Efficient and scalable temporal graph learning in large-scale graphs with distributed clusters, achieving over 1.2 times speedup in training efficiency while maintaining comparable accuracy.",
  },
  foot: {
    doc: {
      title: "Docs",
      item1: "Source Code",
      item2: "Download Dataset",
    },
    contact: {
      title: "Contact Us",
    },
    un: "Institute for Advanced Study, Zhejiang University, Shanghai",
    no1: "Shanghai Public Network Security No.31011502019924",
    no2: "Shanghai ICP No.2021025709-3",
  },
};
